<template>
  <v-card outlined>
    <v-list-item-content class="d-flex align-start">
      <v-col cols="12" md="4">
        <CPTInput
          v-model="protocoloModel"
          v-maska="'###########'"
          label="Protocolo"
          counter="11"
        />
      </v-col>
      <v-col cols="12" md="4">
        <CPTInput
          v-model="matriculaModel"
          v-maska="'###########'"
          label="Matrícula"
          counter="11"
        />
      </v-col>
      <v-col cols="12" md="4">
        <CPTInput v-model="alunoModel" label="Aluno" />
      </v-col>

      <v-col cols="12" md="4">
        <CPTSelect
          v-model="statusModel"
          :items="tipoStatus"
          item-text="label"
          label="Status"
          return-object
        />
      </v-col>

      <v-col cols="12" md="4">
        <CPTAutocomplete
          v-model="unidadeEnsinoModel"
          :items="unidadesEnsino"
          clearable
          item-text="nomeCompleto"
          label="Unidade de Ensino"
          return-object
        />
      </v-col>

      <v-col cols="12" md="4">
        <CPTSelect
          v-model="tipoModel"
          :items="tipoInscricao"
          item-text="label"
          label="Tipo de Inscrição"
          return-object
          clearable
        />
      </v-col>

      <v-col cols="12" md="3">
        <v-checkbox
          v-model="processoJudicialModel"
          label="Processo Judicial"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" md="3">
        <v-checkbox
          v-model="acolhimentoInstitucionalModel"
          label="Acolhimento Institucional"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" md="3">
        <v-checkbox
          v-model="vulnerabilidadeSocialModel"
          label="Vulnerabilidade Social"
        ></v-checkbox>
      </v-col>

      <v-col cols="1">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mt-3 ml-auto"
              color="primary"
              depressed
              fab
              small
              v-on="on"
              @click="limparFiltros"
            >
              <v-icon>
                mdi-filter-remove
              </v-icon>
            </v-btn>
          </template>
          Limpar Filtros
        </v-tooltip>
      </v-col>
    </v-list-item-content>
    <v-card-actions class="d-flex justify-end">
      <CPTBtn
        label="Buscar"
        icon="mdi-magnify"
        :loading="loading"
        @click="$emit('buscar')"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import CPTAutocomplete from "@/components/Autocomplete";
import CPTBtn from "@/components/Btn";
import CPTInput from "@/components/Input";
import CPTSelect from "@/components/Select";
import { statusInscricao } from "./status-inscricao.js";

const tipoStatus = Object.keys(statusInscricao).map((status) => ({
  label: status,
  value: status,
}));

const tipoInscricao = [
  { label: "Cadastro", value: "CADASTRO" },
  { label: "Transferência", value: "TRANSFERENCIA" },
];

export default {
  name: "busca-lista-cadastro",

  components: {
    CPTAutocomplete,
    CPTBtn,
    CPTInput,
    CPTSelect,
  },

  props: {
    matricula: {
      type: String,
      default: "",
    },

    protocolo: {
      type: String,
      default: "",
    },

    aluno: {
      type: String,
      default: "",
    },

    unidadeEnsino: {
      type: Object,
      default: () => {},
    },

    status: {
      type: Object,
      default: () => {},
    },

    vulnerabilidadeSocial: {
      type: Boolean,
      default: false,
    },

    acolhimentoInstitucional: {
      type: Boolean,
      default: false,
    },

    processoJudicial: {
      type: Boolean,
      default: false,
    },

    tipo: {
      type: Object,
      default: () => {},
    },

    loading: {
      type: Boolean,
      default: false,
    },

    unidadesEnsino: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    tipoStatus,
    tipoInscricao,
  }),

  computed: {
    matriculaModel: {
      get() {
        return this.matricula;
      },
      set(value) {
        this.$emit("update:matricula", value);
      },
    },

    protocoloModel: {
      get() {
        return this.protocolo;
      },
      set(value) {
        this.$emit("update:protocolo", value);
      },
    },

    alunoModel: {
      get() {
        return this.aluno;
      },
      set(value) {
        this.$emit("update:aluno", value);
      },
    },

    statusModel: {
      get() {
        return this.status;
      },
      set(value) {
        this.$emit("update:status", value);
      },
    },

    vulnerabilidadeSocialModel: {
      get() {
        return this.vulnerabilidadeSocial;
      },
      set(value) {
        this.$emit("update:vulnerabilidadeSocial", value);
      },
    },

    acolhimentoInstitucionalModel: {
      get() {
        return this.acolhimentoInstitucional;
      },
      set(value) {
        this.$emit("update:acolhimentoInstitucional", value);
      },
    },

    processoJudicialModel: {
      get() {
        return this.processoJudicial;
      },
      set(value) {
        this.$emit("update:processoJudicial", value);
      },
    },

    unidadeEnsinoModel: {
      get() {
        return this.unidadeEnsino;
      },
      set(value) {
        this.$emit("update:unidadeEnsino", value);
      },
    },

    tipoModel: {
      get() {
        return this.tipo;
      },
      set(value) {
        this.$emit("update:tipo", value);
      },
    },
  },

  methods: {
    limparFiltros() {
      this.protocoloModel = "";
      this.matriculaModel = "";
      this.alunoModel = "";
      this.statusModel = null;
      this.unidadeEnsinoModel = null;
      this.tipoModel = null;
      this.processoJudicialModel = false;
      this.acolhimentoInstitucionalModel = false;
      this.vulnerabilidadeSocialModel = false;
    },
  },
};
</script>
